import Api from "../Api";

export interface IndexItem {
  id: number;
  name: string;
  type: string;
}

export interface MetricItem {
  code: string;
  displayName: string;
  type: string;
}

export interface IndexesDataConfig {
  indices: IndexItem[];
  metrics: MetricItem[];
}

export interface ExportFilePayload {
  indices: {id: number, type: string}[];
  metrics: {code: string; displayName: string}[];
  startMonth: string;
  endMonth: string;
  format: "CSV" | "XLSX";
}

class ApiMetrics extends Api {
  static getMetrics() {
    return ApiMetrics.instance.axiosInst.get<IndexesDataConfig>("/internal/export/options");
  }

  static downloadExportFile(payload: ExportFilePayload) {
    return ApiMetrics.instance.axiosInst.post("/internal/export/data", payload, {
      responseType: "blob",
    });
  }
}

export default ApiMetrics;
